<div class="wrapper">
    <ui-svg-icon
        icon="minus-small"
        (click)="zoomOut()" />
    <span> {{ currentZoom() }}% </span>
    <ui-svg-icon
        icon="plus-small"
        (click)="zoomIn()" />
</div>
